import { Injectable } from '@angular/core';
import { Purchases } from '@revenuecat/purchases-capacitor';

/**
 * Thin injectable wrapper around the statically-imported RevenueCat
 * Capacitor `Purchases` plugin proxy.
 *
 * Nothing else in this codebase stubs a static import, so this exists
 * purely as a test seam: CapacitorPurchaseProvider and
 * CapacitorIosOfferResolver depend on this instead of calling
 * `Purchases.*` directly, so specs can substitute it via DI. What
 * still bypasses the adapter and calls `Purchases.*` directly:
 * `isConfigured`, `setLogLevel`, `addCustomerInfoUpdateListener`,
 * `restorePurchases`, `presentCodeRedemptionSheet`, and the
 * attribution calls (`collectDeviceIdentifiers`, `setFBAnonymousID`,
 * `setAttributes`).
 */
@Injectable({ providedIn: 'root' })
export class CapacitorPurchasesAdapter {

  getOfferings(): ReturnType<typeof Purchases.getOfferings> {
    return Purchases.getOfferings();
  }

  configure(
    options: Parameters<typeof Purchases.configure>[0]
  ): ReturnType<typeof Purchases.configure> {
    return Purchases.configure(options);
  }

  logIn(
    options: Parameters<typeof Purchases.logIn>[0]
  ): ReturnType<typeof Purchases.logIn> {
    return Purchases.logIn(options);
  }

  getAppUserID(): ReturnType<typeof Purchases.getAppUserID> {
    return Purchases.getAppUserID();
  }

  purchaseStoreProduct(
    options: Parameters<typeof Purchases.purchaseStoreProduct>[0]
  ): ReturnType<typeof Purchases.purchaseStoreProduct> {
    return Purchases.purchaseStoreProduct(options);
  }

  checkTrialOrIntroductoryPriceEligibility(
    options: Parameters<
      typeof Purchases.checkTrialOrIntroductoryPriceEligibility
    >[0]
  ): ReturnType<
    typeof Purchases.checkTrialOrIntroductoryPriceEligibility
  > {
    return Purchases
      .checkTrialOrIntroductoryPriceEligibility(options);
  }

  getPromotionalOffer(
    options: Parameters<typeof Purchases.getPromotionalOffer>[0]
  ): ReturnType<typeof Purchases.getPromotionalOffer> {
    return Purchases.getPromotionalOffer(options);
  }

  purchaseDiscountedProduct(
    options: Parameters<
      typeof Purchases.purchaseDiscountedProduct
    >[0]
  ): ReturnType<typeof Purchases.purchaseDiscountedProduct> {
    return Purchases.purchaseDiscountedProduct(options);
  }
}
